import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CONTACT_OPT_IN_KEY, REQUIRED_OPT_IN_MESSAGE } from '../../../DynamicForm.constants';
export function validateFormField(field, value) {
  var required = field.required,
    name = field.name,
    label = field.label;
  if (required && value !== true) {
    if (name === CONTACT_OPT_IN_KEY) {
      return _defineProperty({}, name, REQUIRED_OPT_IN_MESSAGE);
    }
    return _defineProperty({}, name, "".concat(label, " is required"));
  }
  return {};
}
export function getFieldError(displayErrors, errorMessage) {
  if (displayErrors && errorMessage) {
    return {
      content: errorMessage,
      pointing: 'left'
    };
  }
  return null;
}